// ResetPassword.jsx
import { useState, useContext } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Loader2, LockKeyhole } from "lucide-react";
import { AuthContext } from "../context/AuthContext";

export default function ResetPassword() {
  const { reinitPassword, authError } = useContext(AuthContext);
  const [message, setMessage] = useState('');
  const [errorApi, setErrorApi] = useState(false);
  const [resetOk, setResetOk] = useState(false);
  const [loadingAuth, setLoadingAuth] = useState(false)
  const [params] = useSearchParams();
  const token = params.get('token');
  const navigate = useNavigate();

  const [values, setValues] = useState({
    password: "",
    password2: "",
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((v) => ({ ...v, [name]: value }));
  };

  const validate = () => {
    const e = {};
    if ( values.password.trim().length < 2 ) e.password = "Mot de passe obligatoire";
    if ( values.password.trim() !== values.password2.trim() ) e.password2 = "Confirmation non valide";
    if (Object.keys(e).length !== 0) setLoadingAuth(false)
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  async function handleSubmit(e) {
    setLoadingAuth(true)
    e.preventDefault();
    if (!validate()) return;
    try {
      await reinitPassword({ token, password: values.password.trim() });
      setLoadingAuth(false)
      setErrorApi(false)
      setResetOk(true)
      setMessage('Mot de passe réinitialisé avec succès.');
    } catch {
      setLoadingAuth(false)
      setErrorApi(true)
      setMessage('Erreur lors de la réinitialisation. Veuillez recommencer la procédure.');
    }
  };
  
  const gotoLogin = () => {
    navigate('/auth?section=login');
  }
  const gotoReinitPassword = () => {
    navigate('/auth?section=pwd');
  }

  const baseInput =
    "w-full border border-custom-700 rounded-xl bg-gray-800 border-opacity-20 border-teal-400 px-10 py-2 placeholder-custom-500 focus:outline-none focus:ring-2 focus:ring-custom-700 transition";
  const errorInput = "border-red-500 focus:ring-red-400";

  return (
    <div className="flex items-center justify-center p-4 w-full">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-md bg-gray-800/30 p-8 rounded-2xl shadow-xl"
      >
        <div className=" space-y-6">
          <h1 className="text-2xl font-semibold text-center mb-4 text-white">
            Réinitialisation de mot de passe
          </h1>
          {message === '' && (
            <div className="relative">
              <LockKeyhole className="absolute left-3 top-1/2 -translate-y-1/2" size={18} />
              <input
                type="password"
                name="password"
                value={values.password}
                onChange={handleChange}
                placeholder="Mot de passe"
                className={`${baseInput} ${errors.password ? errorInput : ""}`}
              />
              {errors.password && (
                <p className="absolute -bottom-5 left-0 text-xs text-red-500">
                  {errors.password}
                </p>
              )}
            </div>
          )}
          {message === '' && (
            <div className="relative">
              <LockKeyhole className="absolute left-3 top-1/2 -translate-y-1/2" size={18} />
              <input
                type="password"
                name="password2"
                value={values.password2}
                onChange={handleChange}
                placeholder="Confirmer"
                className={`${baseInput} ${errors.password2 ? errorInput : ""}`}
              />
              {errors.password2 && (
                <p className="absolute -bottom-5 left-0 text-xs text-red-500">
                  {errors.password2}
                </p>
              )}
            </div>
          )}
          {message === '' && (
            <button
              type="submit"
              disabled={loadingAuth}
              className="inline-flex w-full items-center justify-center btn"
            >
              {loadingAuth ? (
                <Loader2 className="h-5 w-5 animate-spin" />
              ) : ('Réinitialiser')}
            </button>
          )}
          {authError && (
            <span
              className="cursor-pointer transition-colors text-red-500 text-center w-full block mt-1"
            >
              {authError}
            </span>
          )}
          {message && <p className='text-center'>{message}</p>}
          {resetOk && (
            <span
              onClick={gotoLogin}
              className="underline cursor-pointer transition-colors text-[11px] text-center w-full block mt-2"
            >
              Se connecter
            </span>
          )}
          {errorApi && (
            <span
              onClick={gotoReinitPassword}
              className="underline cursor-pointer transition-colors text-[11px] text-center w-full block mt-2"
            >
              Réinitialiser mon mot de passe
            </span>
          )}
        </div>
      </form>
    </div>
  );
}
